import script from "./CopyIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./CopyIcon.vue?vue&type=script&setup=true&lang=ts"

import "./CopyIcon.vue?vue&type=style&index=0&id=bf88edb4&scoped=true&lang=scss"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf88edb4"]])

export default __exports__